@let blok = block();

@if (blok.title?.length || blok.subtitle?.length) {
    <div class="my-12">
        @if (blok.title) {
            @switch (blok.titleLevel && +blok.titleLevel) {
                @case (1) {
                    <h1 class="s1-faq--title app-limited-content-width break-words text-4xl md:text-5xl lg:text-6xl">
                        {{ blok.title }}
                    </h1>
                }
                @case (2) {
                    <h2 class="s1-faq--title app-limited-content-width break-words text-4xl md:text-5xl lg:text-6xl">
                        {{ blok.title }}
                    </h2>
                }
                @case (3) {
                    <h3 class="s1-faq--title app-limited-content-width break-words text-4xl md:text-5xl lg:text-6xl">
                        {{ blok.title }}
                    </h3>
                }
                @case (4) {
                    <h4 class="s1-faq--title app-limited-content-width break-words text-4xl md:text-5xl lg:text-6xl">
                        {{ blok.title }}
                    </h4>
                }
                @case (5) {
                    <h5 class="s1-faq--title app-limited-content-width break-words text-4xl md:text-5xl lg:text-6xl">
                        {{ blok.title }}
                    </h5>
                }
                @case (6) {
                    <h6 class="s1-faq--title app-limited-content-width break-words text-4xl md:text-5xl lg:text-6xl">
                        {{ blok.title }}
                    </h6>
                }
                @default {
                    <h2 class="s1-faq--title app-limited-content-width break-words text-4xl md:text-5xl lg:text-6xl">
                        {{ blok.title }}
                    </h2>

                }
            }
        }
        @if (blok.subtitle) {
            <p class="s1-faq--subtitle app-limited-content-width break-words">
                {{ blok.subtitle }}
            </p>
        }
    </div>
}

@if (blok.children?.length) {
    <ul class="s1-faq--list app-limited-content-width">
        @for (item of blok.children; track item._uid) {
            <li s1-faq-item
                [block]="item">
            </li>
        }
    </ul>
}
